
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarSeaIec as ObiRadarSeaIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-sea-iec.js';
 
 
 

 
 export const ObiRadarSeaIec = createComponent({
   react: React,
   tagName: 'obi-radar-sea-iec',
   elementClass: ObiRadarSeaIecElement,
   events: {
     
   }
  });
 
 